export default function($) {
  var speed = 90; // ms

  $('.js-nav-mobile-button').click(function () {
    $('.js-nav-items').toggleClass('nav-items-open');
    $(this).toggleClass('nav-trigger-active');
  });

  $('.menu-item-has-children').click(function () {
    $(this).siblings('.menu-item-has-children--active').each(function(i, sibling) {
      $(sibling).removeClass('menu-item-has-children--active').children('.sub-menu').slideUp(speed);
    });
    $(this).children('.sub-menu').slideToggle(speed);
    $(this).toggleClass('menu-item-has-children--active');
  });

  $(document).click(function(event) {
    if (!$(event.target).closest('.js-nav').length) {
      if ($('.sub-menu').is(":visible")) {
        $('.sub-menu').slideUp(speed);
        $('.menu-item-has-children--active').removeClass('menu-item-has-children--active');
      }
    }
  });

  $(window).on( 'load', function() {
    var hH = $('.header-banner').outerHeight();

    if ($('body').hasClass('logged-in')) {
      var fullhH = hH + 50;
      $('.mobile-nav-items').css({
        'top': fullhH,
        'height': 'calc(100% - '+ fullhH +'px)'
      });
    } else {
      $('.mobile-nav-items').css({
        'top': hH,
        'height': 'calc(100% - '+ hH +'px)'
      });
    }

    $(window).on('resize', function () {
      var rhH = $('.header-banner').outerHeight(),
        fullrhH = rhH + 50;
      if ($('body').hasClass('logged-in')) {
        $('.mobile-nav-items').css({
          'top': fullrhH,
          'height': 'calc(100% - '+ fullrhH +'px)'
        });
      } else {
        $('.mobile-nav-items').css({
          'top': rhH,
          'height': 'calc(100% - '+ rhH +'px)'
        });
      }
    })
    $(window).on('scroll', function () {
      var shH = $('.header-banner').outerHeight();
      $('.mobile-nav-items').css('top', shH);
    })
  });

  $(window).scroll(function() {
    if ($(this).scrollTop() >= 100) {
      $('.js-backtotop').fadeIn();
    } else {
      $('.js-backtotop').fadeOut();
    }
  });
}
